/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsApplicationV2BCSSelectedItem {
    getFixupPrototypeFunction() { return AppSecopsApplicationV2BCSSelectedItem.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsApplicationV2BCSSelectedItem>): AppSecopsApplicationV2BCSSelectedItem {
        let obj = Object.assign(new AppSecopsApplicationV2BCSSelectedItem(), model);
        AppSecopsApplicationV2BCSSelectedItem.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsApplicationV2BCSSelectedItem>): AppSecopsApplicationV2BCSSelectedItem {
        if (!model) return null;
        return AppSecopsApplicationV2BCSSelectedItem.newInstance(<AppSecopsApplicationV2BCSSelectedItem> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsApplicationV2BCSSelectedItem) {
        if (!obj) return;

        models.AppSecopsApplicationV2BCSSelectedItem.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsApplicationV2BCSSelectedItem): boolean {
        Object.setPrototypeOf(obj, AppSecopsApplicationV2BCSSelectedItem.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Question ID
     */
    question_id: string;

    /**
     * Selected option IDs
     */
    options: Array<string>;

}
